export const mapFilterOptionsToFilters = filterOptions => {
  const traveledAsOptions = filterOptions.filter(option => ['all', 'family', 'single', 'couple', 'friends'].includes(option));
  const traveledAs = traveledAsOptions.includes('all') ? [] : traveledAsOptions;
  const hasPhotos = filterOptions.includes('withPhotos') || null;
  const hasTextRating = filterOptions.includes('withText') || null;
  const recommendation = filterOptions.includes('withRecommendation') || (filterOptions.includes('withoutRecommendation') ? false : null);
  return {
    traveledAs,
    hasPhotos,
    hasTextRating,
    recommendation
  };
};